<div rvSpinner="powerbi-loader" [rvShowSpinner]="spinner">
  <div
    class="attribute-editor-component rise-powerbi-container scrollable-component-container scrollable-component-settings te-scrollable-container"
  >
    <div class="attribute-editor-row" [shown]="revokeFailed">
      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <div class="text-sm">
              We could not revoke your access with Power BI at this time. We
              strongly recommend you manually revoke access in your Microsoft
              account.
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <div class="attribute-editor-row">
        <div class="row">
          <div class="col-xs-12">
            <div
              class="form-group"
              [ngClass]="{
                'has-error': authenticateFailed || componentDisconnected,
              }"
            >
              @if (state === states.NotConfigured) {
                <div class="mb-4">
                  Connect to Power BI to access your dashboards or reports.
                </div>
                <button
                  matButton="outlined"
                  class="tw-w-full button-role--provider"
                  type="button"
                  (click)="confirmConnect()"
                >
                  <mat-icon
                    svgIcon="integration-microsoft"
                    aria-hidden="true"
                  ></mat-icon>
                  <span>Continue with Microsoft</span>
                </button>
              } @else {
                <label>Account:</label><br />
                @if (componentDisconnected) {
                  <p class="help-block">
                    <span>The Power BI user disconnected.</span>
                  </p>
                } @else {
                  Power BI is connected to {{ componentAccountUsername }}<br />
                }

                @if (state === states.ConfiguredByMe) {
                  <button
                    matButton="outlined"
                    class="tw-w-full button-role--provider"
                    type="button"
                    (click)="confirmDisconnect()"
                  >
                    <mat-icon
                      svgIcon="integration-microsoft"
                      aria-hidden="true"
                    ></mat-icon>
                    <span>Disconnect from Microsoft</span>
                  </button>
                } @else {
                  <button
                    rv-button
                    variant="secondary"
                    class="tw-w-full tw-mt-[7.5px]"
                    (click)="confirmChange()"
                  >
                    Change Power BI Account
                  </button>
                }
              }
              <p class="help-block" [shown]="authenticateFailed">
                <span
                  >Sorry, it seems there's an issue with authentication.</span
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="attribute-editor-row" [shown]="state !== states.NotConfigured">
      <div class="row">
        <div class="col-xs-12">
          <rv-divider />
        </div>
      </div>
    </div>

    <div class="attribute-editor-row" [shown]="state === states.ConfiguredByMe">
      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <mat-button-toggle-group
              [(ngModel)]="contentType"
              (ngModelChange)="contentTypeChanged()"
            >
              <mat-button-toggle [value]="ContentType.REPORT"
                >Reports</mat-button-toggle
              >
              <mat-button-toggle [value]="ContentType.DASHBOARD"
                >Dashboards</mat-button-toggle
              >
            </mat-button-toggle-group>
          </div>
        </div>
      </div>
    </div>

    <div class="attribute-editor-row" [shown]="state !== states.NotConfigured">
      <div class="row">
        <div class="col-xs-12">
          <div class="form-group" [ngClass]="{ 'has-error': groupsFailed }">
            <label id="te-powerbi-group-id-label" for="te-powerbi-group-id"
              >Workspace:</label
            ><br />
            @if (state === states.ConfiguredByMe) {
              <mat-form-field
                appearance="outline"
                subscriptSizing="dynamic"
                class="tw-w-full"
              >
                <mat-select
                  id="te-powerbi-group-id"
                  name="te-powerbi-group-id"
                  [(ngModel)]="selectedGroup"
                  aria-labelledby="te-powerbi-group-id-label"
                  (ngModelChange)="selectedGroupChanged()"
                  placeholder="Select Workspace"
                >
                  <mat-option value="my-workspace">My Workspace</mat-option>
                  @for (g of groups; track g) {
                    <mat-option [value]="g.id">{{ g.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              @if (groupsFailed) {
                <p class="help-block">
                  <span
                    >Sorry, it seems like we can't provide the list of your
                    workspaces. If the issue persists, contact support.</span
                  >
                </p>
              }
            } @else {
              {{ selectedGroupName ? selectedGroupName : 'none' }}
            }
          </div>
        </div>
      </div>
    </div>

    <div
      class="attribute-editor-row"
      [shown]="
        state !== states.NotConfigured && contentType === ContentType.DASHBOARD
      "
    >
      <div class="row">
        <div class="col-xs-12">
          <div class="form-group" [ngClass]="{ 'has-error': dashboardsFailed }">
            <label
              id="te-powerbi-dashboard-id-label"
              for="te-powerbi-dashboard-id"
              >Dashboard:</label
            ><br />
            @if (state === states.ConfiguredByMe) {
              <mat-form-field
                appearance="outline"
                subscriptSizing="dynamic"
                class="tw-w-full"
              >
                <mat-select
                  id="te-powerbi-dashboard-id"
                  name="te-powerbi-dashboard-id"
                  [(ngModel)]="selectedDashboard"
                  aria-labelledby="te-powerbi-dashboard-id-label"
                  (ngModelChange)="selectedDashboardChanged()"
                  placeholder="Select Dashboard"
                >
                  @for (d of dashboards; track d) {
                    <mat-option [value]="d.id">{{ d.displayName }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              @if (dashboardsFailed) {
                <p class="help-block">
                  <span
                    >Sorry, it seems like we can't provide the list of your
                    dashboards. If the issue persists, contact support.</span
                  >
                </p>
              }
            } @else {
              {{ selectedDashboardName ? selectedDashboardName : 'none' }}
            }
          </div>
        </div>
      </div>
    </div>

    <div
      class="attribute-editor-row"
      [shown]="
        state !== states.NotConfigured && contentType === ContentType.REPORT
      "
    >
      <div class="row">
        <div class="col-xs-12">
          <div class="form-group" [ngClass]="{ 'has-error': reportsFailed }">
            <label id="te-powerbi-report-id-label" for="te-powerbi-report-id"
              >Reports:</label
            ><br />
            @if (state === states.ConfiguredByMe) {
              <mat-form-field
                appearance="outline"
                subscriptSizing="dynamic"
                class="tw-w-full"
              >
                <mat-select
                  id="te-powerbi-report-id"
                  name="te-powerbi-report-id"
                  [(ngModel)]="selectedReport"
                  aria-labelledby="te-powerbi-report-id-label"
                  (ngModelChange)="selectedReportChanged()"
                  placeholder="Select Report"
                >
                  @for (r of reports; track r) {
                    <mat-option [value]="r.id">{{ r.displayName }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              @if (reportsFailed) {
                <p class="help-block">
                  <span
                    >Sorry, it seems like we can't provide the list of your
                    reports. If the issue persists, contact support.</span
                  >
                </p>
              }
            } @else {
              {{ selectedReportName ? selectedReportName : 'none' }}
            }
          </div>
        </div>
      </div>
    </div>

    <div class="attribute-editor-row" [shown]="state !== states.NotConfigured">
      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <div class="flex-row">
              <label
                id="te-powerbi-dashboard-refresh-label"
                class="mt-1"
                for="te-powerbi-dashboard-refresh"
                >Refresh Rate:</label
              >
              <streamline-icon
                matTooltip="Power BI only supports automatic refresh for reports. You can refresh the data of your dashboard by choosing an interval below."
                matTooltipPosition="right"
                matTooltipClass="font-weight-bold"
                ariaLabel="More information"
                runZone
                name="info"
                width="14"
                height="14"
                class="aligner rise-blue pl-2"
              ></streamline-icon>
            </div>
            <mat-form-field
              appearance="outline"
              subscriptSizing="dynamic"
              class="tw-w-full"
            >
              <mat-select
                id="te-powerbi-dashboard-refresh"
                name="te-powerbi-dashboard-refresh"
                [(ngModel)]="refresh"
                aria-labelledby="te-powerbi-dashboard-refresh-label"
                (ngModelChange)="refreshChanged()"
              >
                <mat-option value="0">Never Refresh</mat-option>
                <mat-option value="5">5 minutes</mat-option>
                <mat-option value="30">30 minutes</mat-option>
                <mat-option value="60">60 minutes</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
